import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { switchPrefixCls } from "@/base/components/switch/Switch.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Switch">> = ({
  colorDisabledPrimary,
  colorDisabled,
  colorHandlerDisabled,
}: any) => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${switchPrefixCls}`]: {
      [`&.${switchPrefixCls}-loading`]: {
        [`.${switchPrefixCls}-loading-icon`]: {
          top: "1px",
        },
      },
      [`&.${switchPrefixCls}-checked`]: {
        [`.${switchPrefixCls}-inner`]: {
          paddingInlineStart: 0,
        },
      },
      [`&.${switchPrefixCls}-disabled`]: {
        opacity: 1,
        backgroundColor: colorDisabledPrimary,
        [`&:not(.cso-switch-checked)`]: {
          backgroundColor: colorDisabled,
          [`.cso-switch-handle::before`]: {
            backgroundColor: colorHandlerDisabled,
          },
        },
      },
    },
  },
});

export const useSwitchStyle = genComponentStyleHook(
  ["Switch", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
